
class AuthController {
  constructor() {
    this.name = 'auth';
    this.currentYear = new Date().getFullYear();

  }

  $onInit() {
    //Hdd to do this here since webpack was giving me an issue in css
    $('.login-aside').css('background-image', 'url("assets/app/lot_bg.png")');
  }
}

export default AuthController;



// WEBPACK FOOTER //
// ./client/app/components/auth/auth.controller.js